import React, { useEffect } from 'react';
import { useChatStore } from 'src/common/chat/store';
import { Journey } from 'src/common/interfaces/journey.interface';
import { Node } from 'src/common/interfaces/node.interface';
import { withFixedLoadingSpinner } from 'src/common/components/loading-spinner/hooks/with-loading-spinner';
import { DashboardInboxMessagesBlankState } from './messages/blank-state';
// import { DashboardInboxMessagesFilterBar } from './messages/filter-bar';
import { DashboardInboxMessagesList } from './messages/list';
import { useDashboardInboxStore } from './store';
import { DashboardInboxTitle } from './title';
import isNull from 'lodash/isNull';
import { IconButton } from 'src/common/icon-button';
import { LeftStrongIcon, RightStrongIcon } from 'src/monet/icons';

interface Props {
  onRowClick: (slug: Journey['slug'], stepUUID: Node['uuid'], rowIndex: number) => void;
  isListLoading: boolean;
}

export const DashboardInboxSectionComponent = ({ onRowClick, isListLoading }: Props) => {
  const { connectedChatUser } = useChatStore();
  const { messages, activePage, hasNextPage, isListFetched, setActivePage, totalUnreadMessageCount } =
    useDashboardInboxStore((state) => ({
      activePage: state.activePage,
      hasNextPage: state.hasNextPage,
      isListFetched: state.isListFetched,
      updateListParams: state.updateListParams,
      totalUnreadMessageCount: state.totalUnreadMessageCount,
      setActivePage: state.setActivePage,
      messages: state.messages,
    }));

  const isMessageListEmpty = messages.length === 0;

  const showBlankState = isListFetched && activePage === 1 && isMessageListEmpty;

  const onRowClicked = (index: number) => {
    const { alias, stepUUID } = messages[index];
    onRowClick(alias.slug, stepUUID, index);
  };

  // const onTableHeaderClicked = (params: InboxListParams) => {
  //   updateListParams(params);
  // };

  useEffect(() => {
    return () => {
      setActivePage(1);
    };
  }, []);

  // const onSearchInputChanged = (value: string) => {
  //   console.info({ value }, ' < value');
  // };

  if (totalUnreadMessageCount === -1 && isNull(connectedChatUser)) {
    return null;
  }

  const onPagingButtonClicked = (goPrev?: boolean) => () => {
    setActivePage(goPrev ? activePage - 1 : activePage + 1);
  };

  return (
    <div className='flex flex-col gap-6'>
      {totalUnreadMessageCount > -1 && <DashboardInboxTitle unreadMessageCount={totalUnreadMessageCount} />}
      {showBlankState ? (
        <DashboardInboxMessagesBlankState />
      ) : (
        <>
          {/* <DashboardInboxMessagesFilterBar onSearchInputChange={onSearchInputChanged} /> */}
          <div className='flex flex-col gap-8 w-full'>
            {!isMessageListEmpty ? (
              <DashboardInboxMessagesList
                loading={isListLoading}
                onRowClick={onRowClicked}
                messages={messages}
              />
            ) : (
              <span className='text-bedrock-p text-bedrock-black'>No results found</span>
            )}
            {(hasNextPage || activePage !== 1) && (
              <div className='flex sticky bottom-0 bg-bedrock-white py-4 gap-4'>
                <IconButton disabled={activePage === 1} onClick={onPagingButtonClicked(true)}>
                  <LeftStrongIcon />
                </IconButton>
                <IconButton disabled={!hasNextPage} onClick={onPagingButtonClicked()}>
                  <RightStrongIcon />
                </IconButton>
              </div>
            )}
          </div>
        </>
      )}
    </div>
  );
};

export const DashboardInboxSection = withFixedLoadingSpinner(DashboardInboxSectionComponent);
